import { render, staticRenderFns } from "./VendingFormCatalog.vue?vue&type=template&id=517841d9"
import script from "./VendingFormCatalog.vue?vue&type=script&lang=js"
export * from "./VendingFormCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports